import { Filter } from "lucide-react";

/**
 * Banner mostrato quando una lista è aperta filtrata per stato (?stato=), con
 * link per rimuovere il filtro. Stesso impianto di RitardoBanner, ma in tono
 * neutro: un filtro per stato non segnala un problema, a differenza dei
 * ritardi, quindi non usa il rosso.
 *
 * Il pallino riprende il colore della fetta del donut da cui si è arrivati,
 * così il collegamento fra grafico e lista resta visibile.
 */
export function StatoFilterBanner({
  stato,
  colore,
  conteggio,
  onRemove,
}: {
  stato: string;
  colore: string;
  conteggio: number;
  onRemove: () => void;
}) {
  return (
    <div className="mb-4 flex items-center justify-between gap-3 rounded-lg border border-line bg-black/[0.02] px-4 py-2.5 text-sm">
      <span className="flex min-w-0 items-center gap-2 text-ink/70">
        <Filter className="h-4 w-4 shrink-0 text-ink/40" aria-hidden="true" />
        <span className="shrink-0">Filtrati per stato:</span>
        <span className="h-2 w-2 shrink-0 rounded-full" style={{ backgroundColor: colore }} />
        <span className="truncate font-semibold text-ink" title={stato}>
          {stato}
        </span>
        <span className="shrink-0 tabular-nums text-ink/50">({conteggio})</span>
      </span>
      <button type="button" onClick={onRemove} className="shrink-0 font-semibold text-primary hover:underline">
        Rimuovi filtro
      </button>
    </div>
  );
}
